import {
    createStore
} from 'vuex';
//import createPersistedState from 'vuex-persistedstate';
export default createStore({
    state: {
        isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
        userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
        //isAuthenticated: false,
        //userInfo: {}, // 存储用户信息
        // patientRecords: [], // 存储患者记录
    },
    mutations: {

        // setAuthenticated(state, value) {
        //     state.isAuthenticated = value;
        //     localStorage.setItem('isAuthenticated', value);
        // },
        login(state) {
            state.isAuthenticated = true;
            localStorage.setItem('isAuthenticated', 'true'); // 存储登录状态
        },
        setUserInfo(state, info) {
            state.userInfo = info;
            localStorage.setItem('userInfo', JSON.stringify(info));
        },
        clearState(state) {
            state.isAuthenticated = false;
            localStorage.removeItem('isAuthenticated'); // 移除登录状态
            state.userInfo = null;
            localStorage.clear();
        },
        // login(state) {
        //     state.isAuthenticated = true;
        //     localStorage.setItem('isAuthenticated', 'true'); // 存储登录状态
        // },
        // logout(state) {
        //     state.isAuthenticated = false;
        //     localStorage.removeItem('isAuthenticated'); // 移除登录状态
        //     localStorage.removeItem('userInfo'); // 移除登录状态
        //     state.userInfo = {}; // 清除用户信息

        //     // 同时清除 localStorage
        //     localStorage.removeItem('vuex');
        // },
        // setUserInfo(state, userInfo) {
        //     state.userInfo = userInfo; // 设置用户信息
        //     localStorage.setItem('userInfo', JSON.stringify(userInfo)); // 缓存状态
        // },

        // setAuthenticated(state, value) {
        //     state.isAuthenticated = value;
        //     localStorage.removeItem('isAuthenticated'); // 移除登录状态
        //     //localStorage.setItem('isAuthenticated', 'false'); // 存储登录状态
        // },
    },
    actions: {
        login({
            commit
        }) {
            commit('login');
        },
        logout({
            commit
        }) {
            commit('clearState')
        },
        setUserInfo({
            commit
        }, userInfo) {
            commit('setUserInfo', userInfo); // 设置用户信息
        }
        // login({
        //     commit
        // }) {
        //     commit('login');
        // },
        // logout({
        //     commit
        // }) {
        //     localStorage.clear(); // 清除所有本地存储
        //     commit('logout');
        // },
        // setUserInfo({
        //     commit
        // }, userInfo) {
        //     commit('setUserInfo', userInfo); // 设置用户信息
        // }
    },
    // getters: {
    //     isAuthenticated: state => state.isAuthenticated,
    //     userInfo: state => state.userInfo, // 获取用户信息
    // },
    // plugins: [
    //     createPersistedState({
    //         key: 'vuex', // localStorage 中的键名
    //         paths: ['isAuthenticated', 'userInfo'], // 需要持久化的状态路径
    //         storage: window.localStorage,
    //         // 添加重置函数
    //         reducer: state => ({
    //             isAuthenticated: state.isAuthenticated,
    //             userInfo: state.userInfo,
    //         }),
    //     }),
    // ],
});